import {EventBus} from '@/utils/EventBus';

/** SEO score / Lucy Přejít — open keyword analysis and scroll to the tables. */
export function requestKeywordAnalysisOpen(): void {
    EventBus.$emit('keywords-selection-expand');
}
